/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {DeliveryCardSkeleton} from "./DeliveryCardSkeleton";

export const DeliverySkeleton = () => (
    <>{[...Array(3)].map((item, i) => <DeliveryCardSkeleton key={i}/>)}</>
)
